import { useEffect, useState } from "react";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";

const llmsViewEndpoint = ApiEndpoints.llms.view;
const llmsUpdateEndpoint = ApiEndpoints.llms.update;

export default function LlmsEditor() {
  const [content, setContent] = useState("");
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const pagename = {
    name: "LLMS Management",
    user: "Admin",
    innerpage: "LLMS Management",
  };

  const fetchLlms = async () => {
    try {
      const response = await ApiRequest("GET", llmsViewEndpoint);
      setContent(response?.llms?.content || "");
    } catch (error) {
      console.log(error);
      toast.error("Unable to load LLMS text.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLlms();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);

    try {
      setSaving(true);
      const response = await ApiRequest("POST", llmsUpdateEndpoint, { content });
      toast.success(response.message);
    } catch (error) {
      const apiErrors = error?.response?.data?.errors || [];
      setErrors(apiErrors);
      toast.error(error?.response?.data?.message || "Unable to update LLMS text.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-content-page">
        <form onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>LLMS Text</label>
                  </div>
                  <textarea
                    name="content"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    className="form-control"
                    rows="24"
                    disabled={loading || saving}
                    style={{ height: "auto", fontFamily: "monospace", whiteSpace: "pre", overflow: "auto" }}
                  />
                </div>
              </div>

              {errors.length > 0 && (
                <div className="col-lg-12">
                  <div className="alert alert-danger">
                    {errors.map((error) => (
                      <div key={error}>{error}</div>
                    ))}
                  </div>
                </div>
              )}

              <div className="col-lg-12">
                <button className="default-btn" type="submit" disabled={loading || saving}>
                  {saving ? "Saving..." : "Save LLMS Text"}<span></span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
